import { HANDLE_AGENT, RESET } from '../actions';

const initialState = {
    agentList: [],
    agentCopy: [],
    search: "",
    roleFilter: ""
};

const AgentDetails = (state = initialState, action) => {
    
    switch (action.type) {
        case HANDLE_AGENT:
            return {
                ...state,
                ...action.data
            };
        case RESET:
            return initialState;
        default:
            return state;
    }
};

export default AgentDetails;